export function canRespondToCpmSubmissionAppeal({
  campaign,
  submission,
  appeal,
}: {
  campaign: { status?: string | null } | null | undefined;
  submission: {
    admin_approval?: string | null;
    disqualified?: boolean | null;
    content_review_group?: unknown;
    content_review_group_id?: string | null;
    disapproved_at?: string | Date | null;
  } | null | undefined;
  appeal: { status?: string | null } | null | undefined;
}): { ok: true; code: null } | { ok: false; code: string } {
  if (!campaign || campaign.status !== 'active') {
    return { ok: false, code: 'campaign_not_active' };
  }
  if (!appeal || appeal.status !== 'needs_more_info') {
    return { ok: false, code: 'appeal_not_awaiting_response' };
  }
  if (!submission || submission.admin_approval !== 'disapproved') {
    return { ok: false, code: 'not_disapproved' };
  }
  if (submission.disqualified) {
    return { ok: false, code: 'disqualified_submission' };
  }
  if (submission.content_review_group || submission.content_review_group_id) {
    return { ok: false, code: 'grouped_submission' };
  }
  return { ok: true, code: null };
}
